// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2P9yQ","modalFooterButton":"ModalNotes_modalFooterButton__1YLqN"};